import { Guid } from "@/Common/Models/Guid";
import { PrescriptionRenewalMedicationItemResponse } from "../Api/Dto/PrescriptionRenewalMedicationItemResponse";
import { EnumPrescriptionRenewalMedicationsStatus } from "./EnumPrescriptionRenewalMedicationsStatus";

export class PrescriptionRenewalMedications {
    public prescriptionRenewalId: Guid;
    public medicationId: Guid | string;
    public status: EnumPrescriptionRenewalMedicationsStatus;
    public rejectReason: string | null;
    public rejectNotes: string | null;
    public createdDate: Date;
    public createdByEmployeeId: Guid | null;
    public ceaseReason: string | null;
    public ceaseDate: Date | null;
    public pendingStatus: number | null;
    public discontinueReasonLookupId: string | null;

    constructor(fields: Partial<PrescriptionRenewalMedications>) {
        Object.assign(this, fields);
    }

    public static fromResponseModel(prescriptionRenewalMedicationItemResponse: PrescriptionRenewalMedicationItemResponse): PrescriptionRenewalMedications {
        if (!prescriptionRenewalMedicationItemResponse)
            return;

        return new PrescriptionRenewalMedications({
            prescriptionRenewalId: prescriptionRenewalMedicationItemResponse.PrescriptionRenewalId,
            medicationId: prescriptionRenewalMedicationItemResponse.MedicationId,
            status: prescriptionRenewalMedicationItemResponse.Status,
            rejectReason: prescriptionRenewalMedicationItemResponse.RejectReason,
            rejectNotes: prescriptionRenewalMedicationItemResponse.RejectNotes,
            createdDate: prescriptionRenewalMedicationItemResponse.CreatedDate,
            createdByEmployeeId: prescriptionRenewalMedicationItemResponse.CreatedByEmployeeId,
            ceaseReason: prescriptionRenewalMedicationItemResponse.CeaseReason,
            ceaseDate: prescriptionRenewalMedicationItemResponse.CeaseDate,
            pendingStatus: prescriptionRenewalMedicationItemResponse.PendingStatus,
            discontinueReasonLookupId: prescriptionRenewalMedicationItemResponse.DiscontinueReasonLookupId
        });
    }
}
